/**
 * Handoff 33: identity for users who sign in without an email claim
 * (common for Entra work accounts). UID is the key; email is optional.
 */

export function extractPreferredUsername(profile) {
  if (!profile || typeof profile !== 'object') return '';
  const raw = profile.preferred_username || profile.upn || profile.userPrincipalName || '';
  return String(raw).trim();
}

export function resolveSignInIdentity(user, hints = {}) {
  const preferredUsername =
    String(hints.preferredUsername || '').trim() || extractPreferredUsername(hints.profile);
  const email = (user && user.email && String(user.email).trim()) || '';
  const fromAuth = (user && user.displayName && String(user.displayName).trim()) || '';
  const displayName = fromAuth || preferredUsername;
  return { email, displayName, preferredUsername };
}

/** Fields to persist on users/{uid}. Omits empty email. */
export function userDocIdentityFields(user, hints = {}) {
  const { email, displayName, preferredUsername } = resolveSignInIdentity(user, hints);
  const fields = { displayName };
  if (email) fields.email = email;
  if (preferredUsername) fields.preferredUsername = preferredUsername;
  return fields;
}

export function canQueryUsersByEmail(user) {
  return Boolean(user && user.emailVerified && user.email);
}
